import React from 'react';
import { Form } from 'react-bootstrap';
import ClinicalButton from '../../doctor/ui/ClinicalButton';
import ReceptionModalShell, { ReceptionModalSection, ReceptionFormField } from '../../receptionist/ui/ReceptionModalShell';

export default function NurseIntakeConfirmModal({
  show,
  onHide,
  saving = false,
  onSubmit,
  patientProfile = null,
  siteName = '',
  title = "Accueillir à l'infirmerie",
  subtitle = '',
  submitLabel = "Accueillir à l'infirmerie",
  visitNotes,
  onVisitNotesChange,
  visitNotesPlaceholder = 'Réception depuis poste infirmerie…',
  orientSymptoms,
  onOrientSymptomsChange,
  orientSymptomsPlaceholder = 'Symptômes ou motif de la visite…'
}) {
  const footer = (
    <div className="recv-intake-orient-footer">
      <ClinicalButton variant="secondary" onClick={onHide} disabled={saving}>
        Annuler
      </ClinicalButton>
      <ClinicalButton
        variant="save"
        className="recv-intake-orient-submit"
        onClick={onSubmit}
        disabled={saving}
        loading={saving}
        icon={saving ? undefined : 'check'}
      >
        {saving ? 'Enregistrement…' : submitLabel}
      </ClinicalButton>
    </div>
  );

  return (
    <ReceptionModalShell
      show={show}
      onHide={onHide}
      disableClose={saving}
      scrollable
      centered
      size="lg"
      title={title}
      subtitle={
        subtitle ||
        (siteName
          ? `Passage NURSING sur ${siteName} — visible dans la file infirmerie.`
          : 'Orientation infirmerie automatique.')
      }
      footer={footer}
    >
      {patientProfile ? (
        <ReceptionModalSection title="Patient">
          <p className="mb-1 fw-semibold">{patientProfile.displayName}</p>
          <p className="text-muted small mb-0">{patientProfile.details.join(' · ')}</p>
        </ReceptionModalSection>
      ) : null}

      <ReceptionModalSection title="Informations du passage">
        <ReceptionFormField label="Notes d'accueil (optionnel)" htmlFor="nurse-intake-notes">
          <Form.Control
            id="nurse-intake-notes"
            as="textarea"
            rows={2}
            value={visitNotes}
            onChange={(e) => onVisitNotesChange(e.target.value)}
            placeholder={visitNotesPlaceholder}
          />
        </ReceptionFormField>
        <ReceptionFormField
          label="Motif transmis au dossier (optionnel)"
          htmlFor="nurse-intake-symptoms"
          className="mb-0"
        >
          <Form.Control
            id="nurse-intake-symptoms"
            as="textarea"
            rows={2}
            value={orientSymptoms}
            onChange={(e) => onOrientSymptomsChange(e.target.value)}
            placeholder={orientSymptomsPlaceholder}
          />
        </ReceptionFormField>
      </ReceptionModalSection>
    </ReceptionModalShell>
  );
}
